import { CheckListGroup, CheckListItem, CheckListItemBase } from '@/codebook/check-list/check-list.model';
import { components } from '@/common/bag-api';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';
import { Location } from '@/reservation/reservation.model';

export interface DescriptionItem {
	isRequired: boolean;
	comment: string;
	descriptionHeader: CamelCaseKeys<components['schemas']['DescriptionHeader']>;
	description: string;
	descriptionHeaderTitle: string;
	use: OfferTransportKind;
}

export interface DescriptionPayload {
	descriptionHeader: CamelCaseKeys<components['schemas']['DescriptionHeader']>;
	description: string;
	use: OfferTransportKind;
}

export type DescriptionRequirementResult = CamelCaseKeys<components['schemas']['DescriptionRequirement']>;

export type Product = CamelCaseKeys<components['schemas']['Product']>;

export type ComfortTwinProduct = Pick<Product, 'id' | 'code' | 'name'>;

export type ProductCard = CamelCaseKeys<components['schemas']['ProductCard']>;

export type ProductGuide = CamelCaseKeys<components['schemas']['ProductGuide']>;

export type ProductHotel = CamelCaseKeys<components['schemas']['ProductHotel']>;

export type ProductTicket = CamelCaseKeys<components['schemas']['ProductTicket']>;

export type ProductTransitCountry = {
	id: number | null;
	location: Location | null;
	fee: number | null;
};

export type ProductTransitCountryPayload = Omit<ProductTransitCountry, 'location'> & {
	location: number;
};

export enum FieldType {
	TEXT = 'text',
	NUMBER = 'number',
	TEXTAREA = 'textarea',
	SELECT = 'select',
	EMAIL = 'email',
	PHONE = 'phone',
}

export interface FieldConfig<T = unknown> {
	key: string;
	label: string;
	type: FieldType;
	placeholder?: string;
	required?: boolean;
	min?: number;
	max?: number;
	apiOptions?: { valueApiKey: string; labelApiKey: string; apiKey: string; searchApiKey: string };
	options?: any;
	initialValue?: T | null;
	disabled?: boolean;
}

export interface ProductOrganizationDialogConfig {
	title: string;
	fields: FieldConfig[];
	configType: 'cards' | 'guides' | 'hotels' | 'tickets';
}

export interface ProductOrganizationTableTemplate {
	key: FieldConfig['key'];
	label: FieldConfig['label'];
}

export type DialogResultOutput = {
	[key in ProductOrganizationDialogConfig['configType']]: { [key in FieldConfig['key']]: unknown };
};

export type CheckListGroupsWithSelection = CheckListGroup & {
	selected: boolean;
	showActions: boolean;
};

export type CheckListItemsWithSelection = CheckListItem & {
	selected: boolean;
	disabled?: boolean;
};

export interface CheckListSelectionPayload {
	checkpointGroups: number[];
	checkpoints: number[];
}

export interface ApiPaginationVariables {
	offset: number;
	limit: number;
	isLoading: boolean;
	allLoaded: boolean;
}

export type CheckListGroupsSelectionWithApi = ApiPaginationVariables & {
	groups: CheckListGroupsWithSelection[];
};

export type CheckListItemsSelectionWithApi = ApiPaginationVariables & { items: CheckListItemsWithSelection[] };
